module.exports = __webpack_public_path__ + "static/img/threeDManage.48dc6ab0.png";